import React from "react";
import { HelpCircle } from "lucide-react";
import { Card } from "@/components/Card/Card";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { ConversionRateMetrics } from "../../api/fetchROIDashboardData/types";

interface ConversionRateCardProps {
  conversionRate: ConversionRateMetrics | null;
}

export const ConversionRateCard: React.FC<ConversionRateCardProps> = ({
  conversionRate,
}) => {
  const currentRate = conversionRate?.currentRate;
  const changeFromLastMonth = conversionRate?.changeFromLastMonth;

  const formatPercentage = (value: number | null | undefined): string => {
    if (value === null || value === undefined) {
      return "N/A";
    }
    return `${value.toFixed(1)}%`;
  };

  const isPositiveChange =
    changeFromLastMonth !== null &&
    changeFromLastMonth !== undefined &&
    changeFromLastMonth > 0;
  const isNegativeChange =
    changeFromLastMonth !== null &&
    changeFromLastMonth !== undefined &&
    changeFromLastMonth < 0;

  return (
    <Card className="w-full">
      <div className="p-6">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-sm text-gray-600 dark:text-gray-400">
            Conversion Rate
          </span>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400 cursor-help" />
              </TooltipTrigger>
              <TooltipContent className="max-w-xs">
                <p>
                  The percentage of people who received your direct mail and
                  became customers. Industry average is 2-5%, so anything above
                  5% is excellent.
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>

        <div className="text-3xl font-bold text-gray-900 dark:text-white">
          {formatPercentage(currentRate)}
        </div>

        {changeFromLastMonth !== null && changeFromLastMonth !== undefined && (
          <div
            className={`flex items-center gap-1 mt-1 text-sm ${
              isPositiveChange
                ? "text-green-600"
                : isNegativeChange
                  ? "text-red-600"
                  : "text-gray-500"
            }`}
          >
            <span>
              {isPositiveChange ? "\u2191" : isNegativeChange ? "\u2193" : ""}{" "}
              {Math.abs(changeFromLastMonth).toFixed(1)}% from last month
            </span>
          </div>
        )}
      </div>
    </Card>
  );
};
